<script>
	import { scaleAdOnHover, startAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// RIESA-0002A-Pasta-zu-allem-800x250-C-adform
		pasta800: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/08.loesungen/RIESA-800x250/backup.webp',
			imageAltText: 'Riesa - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/08.loesungen/RIESA-800x250/index.html',
			playTimeMs: 32000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 800,
			origHeight: 250
		},
		// RIESA-0002A-Pasta-zu-allem-300x600-B-adform
		pasta300: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/08.loesungen/RIESA-300x600/backup.webp',
			imageAltText: 'Riesa - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/08.loesungen/RIESA-300x600/index.html',
			playTimeMs: 32000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 300,
			origHeight: 600
		}
	}
</script>

<div class="pasta marginbox">
	<h3>{getText("10.08.01_h3")}</h3>
	<p>{getText("10.08.02_p")}</p>
	<div class="commercials-container">
		<img loading="lazy" alt="Chefkoch-Website mit Ads des Pastaherstellers Riesa" src="./../img/10.Appetit_Digitalisieren/08.loesungen/website-screenshot.webp">
		<!-- Beginning - Ad: pasta800 -->
		<div bind:this={ads.pasta800.element} class="pasta800"
			 style="
					 --scale: {ads.pasta800.scale};
					 --origWidth: {ads.pasta800.origWidth || 0}px;
					 --origHeight: {ads.pasta800.origHeight || 0}px;
				">
			{#if ads.pasta800.playing}
				<div class="commercial" class:playing={ads.pasta800.playing}>
					<!-- PLAYING -->
					<div class="container-overlay">
						<img loading="lazy" alt={ads.pasta800.imageAltText} src={ads.pasta800.fallbackImgUrl}/>
						<iframe class="scaled-iframe" scrolling="no" src={ads.pasta800.iframeIndexUrl}
								style="--bg-image: url('{ads.pasta800.fallbackImgUrl}')"
								on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
					</div>
				</div>
			{:else}
				<div use:scaleAdOnHover class="commercial" class:playing={ads.pasta800.playing} on:click={() => startAd(ads.pasta800, () => ads = ads)}>
					<!-- NOT PLAYING -->
					<div class="container-overlay">
						<img loading="lazy" alt={ads.pasta800.imageAltText} src={ads.pasta800.fallbackImgUrl}/>
						<button aria-label="play Ad - {ads.pasta800.imageAltText}" class="playbutton"></button>
					</div>
				</div>
			{/if}
		</div>
		<!-- End - Ad -->
		<!-- Beginning - Ad: pasta300 -->
		<div bind:this={ads.pasta300.element} class="pasta300"
			 style="
					 --scale: {ads.pasta300.scale};
					 --origWidth: {ads.pasta300.origWidth || 0}px;
					 --origHeight: {ads.pasta300.origHeight || 0}px;
				">
			{#if ads.pasta300.playing}
				<div class="commercial" class:playing={ads.pasta300.playing}>
					<!-- PLAYING -->
					<div class="container-overlay">
						<img loading="lazy" alt={ads.pasta300.imageAltText} src={ads.pasta300.fallbackImgUrl}/>
						<iframe class="scaled-iframe" scrolling="no" src={ads.pasta300.iframeIndexUrl}
								style="--bg-image: url('{ads.pasta300.fallbackImgUrl}')"
								on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
					</div>
				</div>
			{:else}
				<div use:scaleAdOnHover class="commercial" class:playing={ads.pasta300.playing} on:click={() => startAd(ads.pasta300, () => ads = ads)}>
					<!-- NOT PLAYING -->
					<div class="container-overlay">
						<img loading="lazy" alt={ads.pasta300.imageAltText} src={ads.pasta300.fallbackImgUrl}/>
						<button aria-label="play Ad - {ads.pasta300.imageAltText}" class="playbutton"></button>
					</div>
				</div>
			{/if}
		</div>
		<!-- End - Ad -->
	</div>
	<p class="caption">{getText("10.08.03_caption")}</p>
	<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	div {
		margin-bottom: $spacing-mobile;
		width: 100%;
		
		h3 {
			margin-bottom: $media-gap;
		}
		
		p:first-of-type {
			@include for-tablet-landscape-up {
				width: 90%;
			}
		}
		
		p {
			padding: 0;
			
			@media screen and (min-width: $breakpoint-tablet) {
				grid-column-start: 1;
				grid-column-end: 2;
				grid-row-start: 3;
				grid-row-end: 4;
				padding: 0;
			}
		}
		
		p:first-of-type {
			padding-bottom: $spacing-mobile;
		}
	}

	.commercials-container {
		position: relative;

		> img {
			width: 100%;
			margin: 0 auto;
			padding: 0 0 $spacing-mobile 0;

			@media screen and (min-width: $breakpoint-tablet) {
				width: 100%;
				padding: 0;
				margin: 0 0 $media-gap 0;
				grid-column-start: 1;
				grid-column-end: 2;
				grid-row-start: 1;
				grid-row-end: 3;
			}
		}

		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
			line-height: 0;
			margin: 0;
		}

		iframe {
			border: none;
			background-image: var(--bg-image);
			background-size: cover;
		}

		:global(iframe[loaded]) {
			background-image: none !important;
		}

		.pasta800, .pasta300 {
			aspect-ratio: var(--origWidth) / var(--origHeight);

			.container-overlay {
				margin: 0;
				> img {
					width: 100%;
				}
			}
			.content {
				max-width: 100%;
			}
			iframe {
				position: absolute;
				left: 0;
				top: 0;
				scale: var(--scale) !important;
				height: calc(var(--origHeight)) !important;
				width: calc(var(--origWidth)) !important;
				transform-origin: top left;
			}
		}

		.pasta800 {
			position: absolute;
			top: 0;
			width: 58.3%;
			left: 17.2%;
			transform: translateY(32.5%);
		}

		.pasta300 {
			position: absolute;
			top: 0;
			width: 21.5%;
			left: 77%;
			transform: translateY(61.25%);
		}
	}
</style>
